import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import User_Dashbaord_Common_Section from '../user_dashboard_common_section/User_Dashbaord_Common_Section'
import { Add_To_Fav, get_favourite_product_list, Add_To_Cart } from '../../../../api/category_product/Category_Product';
import { User_Authentication } from '../../../../user_authentication/User_Authentication';
import { toast } from 'react-toastify'
import Loader from '../../../../loader/Loader';
import { IMG_BASE_URL } from '../../../../config/Config';
import { Link, useNavigate } from 'react-router-dom';
import { MdShoppingCart } from "react-icons/md";
import { MdDelete } from "react-icons/md";

import { useDispatch, useSelector } from 'react-redux';
import { fetchWishlist } from '../../../../redux/actions/wishlistActions';
import { fetchCartList } from '../../../../redux/actions/cartActions'







const User_Dashboard_Wishlist = () => {
    const date = new Date();
    const [is_loading, set_Is_Loading] = useState(false)
    const [loadingCartId, setLoadingCartId] = useState(null)
    const [loadingDeleteId, setLoadingDeleteId] = useState(null)
    const dispatch = useDispatch();
    const { wishlist = [] } = useSelector((state) => state.wishlist || {});
    const Get_user_is_active = localStorage.getItem("user_is_active")
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 10;

    const navigate = useNavigate();

    // Calculate total pages safely
    const totalPages = Math.ceil(wishlist?.length / productsPerPage) || 1;

    // Calculate the products to display on the current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProduct = wishlist?.slice(startIndex, startIndex + productsPerPage) || [];

    // Pagination controls
    const getPaginationItems = () => {
        const items = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                items.push(i);
            }
        } else {
            if (currentPage <= 3) {
                items.push(1, 2, 3, 4, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                items.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                items.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }
        return items;
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // const handle_get_favourite_product_list = async () => {
    //     try {
    //         const token = User_Authentication();
    //         if (!token) {
    //             toast("User token not found")
    //             set_Is_Loading(false)
    //             throw new Error("User token not found");
    //         }
    //         const response = await get_favourite_product_list({ Authorization: `Bearer ${token}` });
    //         if (response?.data?.status == "200") {
    //             set_WishList(response?.data?.data?.favourite);

    //         }
    //     }
    //     catch (error) {
    //         console.log(error?.message);

    //     }
    // }

    // <--------- Add To Favorite --------->
    const Handle_add_to_favorite = async (cat_id, sub_id, id, isSilent = false) => {
        if (!isSilent) setLoadingDeleteId(id)
        const data = {
            cat_id: cat_id,
            subcat_id: sub_id,
            product_id: id
        }
        try {
            const token = User_Authentication();
            if (!token) {
                toast("User not login here")
                throw new Error("User token not found");
            }
            if (!Get_user_is_active) {
                toast("User not login here")
                return
            }
            const response = await Add_To_Fav(data, { Authorization: `Bearer ${token}` })
            if (response?.status == 200) {

                // await handle_get_favourite_product_list({ Authorization: `Bearer ${token}` })
                dispatch(fetchWishlist())

                toast("Product removed from wishlist");
            }
            else if (response?.response?.data?.status == "500") {
                toast(response?.response?.data?.message)
            }
        }
        catch (error) {
            console.error("error", error)
        } finally {
            if (!isSilent) setLoadingDeleteId(null)
        }
    }

    // Format the date
    const formattedDate = (isoString) => {
        const date = new Date(isoString);
        const dateOptions = {
            year: 'numeric',
            month: 'short',
            day: '2-digit'
        };
        const timeOptions = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };
        const formattedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(date);
        const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);
        return `${formattedDate} | ${formattedTime}`;
    };

    // useEffect(() => {
    //     handle_get_favourite_product_list();
    // }, [])

    useEffect(() => {
        const get_wishlist = async () => {
            const result = await dispatch(fetchWishlist());
            if (result?.unauthorized) {
                localStorage.removeItem("user_token");
                localStorage.removeItem("user_is_active");
                toast("Token Expired. Please Login Again.");
                navigate("/user-login");

            }
        }
        get_wishlist();
    }, [dispatch]);


    const Handle_Add_To_cart = async (product_result) => {
        try {
            const token = User_Authentication();
            if (!token) {
                toast.error("User is not logged in.")
                setTimeout(() => {
                    navigate("/user-login")
                }, 1000);
            }
            else {
                setLoadingCartId(product_result?.product_id)
                await Handle_add_to_favorite(product_result?.cat_id, product_result?.subcat_id, product_result?.product_id, true)
                navigate(`/product/${product_result?.product?.slug}`)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoadingCartId(null)
        }
    }


    return (
        <div>
            {/* <----------- Header section's ------------> */}
            <Header />
            {/* <-------- ToastContainer ------------> */}
            {/* <--------- user Wishlist section's ----------> */}
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        <section className="gi-faq py-[40px] max-[767px]:py-[30px] gi-wishlist">
                            <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5 w-full px-[12px]">
                                <div className="section-title-2 w-full pb-[20px] flex flex-col justify-center items-center">
                                    <h1 className="gi-title mb-[0] text-[26px] font-semibold text-[#4b5966] relative inline p-[0] capitalize leading-[1]">Product <span className="text-[#9D2326]">Wishlist</span></h1>
                                    <p className="max-w-[400px] mt-[15px] text-[14px] text-[#777] text-center leading-[23px]">Your product wish is our first priority.</p>
                                </div>
                                <div className="w-full">
                                    <div className="w-full my-4 sm:my-10">

                                        <div className="w-full bg-white shadow-xl p-4 sm:p-5">

                                            <div className="my_account w-full space-x-2 md:space-x-10 flex">
                                                <User_Dashbaord_Common_Section />
                                                <div className="flex-1 min-w-0 mt-5" >
                                                    <div className="item-body dashboard-wrapper w-full">
                                                        <div className="relative w-full overflow-x-auto sm:rounded-lg">
                                                            {
                                                                wishlist?.length > 0 ? (
                                                                    <>
                                                                        <table className="table w-full mb-[1rem]">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">ID</th>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Image</th>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Name</th>
                                                                                    {/* <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Date</th> */}
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Price</th>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Status</th>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Actions</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody className="wish-empt border-t-[3px] border-solid border-[#eee] border-solid border-[#dee2e6]">
                                                                                {
                                                                                    currentProduct?.map((wishlist_result, index) => {
                                                                                        return (
                                                                                            <tr className="pro-gl-content">
                                                                                                <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-[#777] tracking-[0.02rem]">{index + 1}</span></td>
                                                                                                <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><img className="prod-img h-[40px] w-[40px]" src={`${IMG_BASE_URL}${wishlist_result?.product?.single_image?.image_url}`} alt="product image" /></td>
                                                                                                <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-[#777] tracking-[0.02rem]">{wishlist_result?.product?.name}</span></td>
                                                                                                {/* <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-[#777] tracking-[0.02rem]">{formattedDate(wishlist_result?.created_at)}</span></td> */}
                                                                                                <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-[#777] tracking-[0.02rem]">Rs.{wishlist_result?.product?.purchase_price}</span></td>
                                                                                                {
                                                                                                    wishlist_result?.product?.current_stock > 0 ? (
                                                                                                        <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-[#5caf90] tracking-[0.02rem]">Available</span></td>
                                                                                                    ) : (
                                                                                                        <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-red-600 tracking-[0.02rem]">Out of Stock</span></td>
                                                                                                    )
                                                                                                }
                                                                                                <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium" >
                                                                                                    <div className='flex justify-start gap-1'>


                                                                                                        <span className="tbl-btn py-[14px] flex text-[#777]"

                                                                                                        >
                                                                                                            {/* <button type='button' className="w-full text-[12px] uppercase rounded text-center px-3 py-1.5 inline-block  border-gray-900 text-white hover:border-gray-900 bg-red-500
                                                                                                    hover:bg-red-800" title="Add To Cart">
                                                                                                            Remove
                                                                                                        </button> */}
                                                                                                            {loadingDeleteId === wishlist_result?.product_id ? (
                                                                                                                <span className="inline-block h-5 w-5 rounded-full border-2 border-red-600 border-t-transparent animate-spin"></span>
                                                                                                            ) : (
                                                                                                                <MdDelete size={20} className="text-red-600 cursor-pointer"
                                                                                                                    onClick={() => {
                                                                                                                        Handle_add_to_favorite(wishlist_result?.cat_id, wishlist_result?.subcat_id, wishlist_result?.product_id)
                                                                                                                    }} />
                                                                                                            )}
                                                                                                        </span>
                                                                                                        <span className="tbl-btn py-[14px] flex text-[#777]"
                                                                                                        >
                                                                                                            {/* <button type='button' className="w-full text-[12px] uppercase rounded text-center px-3 py-1.5 inline-block border border-gray-900 text-gray-700 hover:text-white hover:border-gray-900 hover:bg-gray-900" title="Add To Cart">
                                                                                                            Add to Cart
                                                                                                        </button> */}

                                                                                                            {loadingCartId === wishlist_result?.product_id ? (
                                                                                                                <span className="inline-block h-5 w-5 rounded-full border-2 border-green-800 border-t-transparent animate-spin"></span>
                                                                                                            ) : (
                                                                                                                <MdShoppingCart size={20} className="text-green-800 cursor-pointer"
                                                                                                                    onClick={() => {
                                                                                                                        Handle_Add_To_cart(wishlist_result)
                                                                                                                    }} />
                                                                                                            )}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                        {/* <!-- Pagination Start --> */}
                                                                        <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                                                            <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, currentProduct?.length)} of {currentProduct?.length} Products</span>
                                                                            <ul className="gi-pro-pagination-inner flex gap-1">
                                                                                {currentPage > 1 && (
                                                                                    <li>
                                                                                        <button
                                                                                            onClick={handlePrev}
                                                                                            className="next w-auto text-[#fff] bg-[#5caf90] bg-red-500 text-[14px] px-2 rounded"
                                                                                        >
                                                                                            Prev
                                                                                        </button>
                                                                                    </li>
                                                                                )}
                                                                                {getPaginationItems().map((page, index) => {
                                                                                    if (page === '...') {
                                                                                        return (
                                                                                            <li key={`ellipsis-${index}`} className="inline-block float-left">
                                                                                                <span className="transition-all duration-[0.3s] ease-in-out text-[#777] text-[14px]">
                                                                                                    ...
                                                                                                </span>
                                                                                            </li>
                                                                                        );
                                                                                    }
                                                                                    return (
                                                                                        <li key={page} className="inline-block float-left">
                                                                                            <button
                                                                                                onClick={() => handlePageChange(page)}
                                                                                                className={`transition-all duration-[0.3s] ease-in-out font-light 
                                                                                                    text-[#777] bg-[#eee] px-2
                                                                                                    text-[14px] rounded
                                                                                                    ${currentPage === page ? 'active bg-red-500 text-white' : 'bg-gray-300 text-black'}`}
                                                                                            >
                                                                                                {page}
                                                                                            </button>
                                                                                        </li>
                                                                                    );
                                                                                })}
                                                                                {currentPage < totalPages && (
                                                                                    <li>
                                                                                        <button
                                                                                            onClick={handleNext}
                                                                                            className="next w-auto text-[#fff] px-2 bg-[#5caf90] text-[14px] rounded"
                                                                                        >
                                                                                            Next
                                                                                        </button>
                                                                                    </li>
                                                                                )}
                                                                            </ul>

                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <div className='flex flex-col items-center justify-center py-10 w-full'>
                                                                        <h5 className="mb-4 text-gray-500 font-semibold text-lg uppercase">Your Wishlist is Empty</h5>
                                                                        <Link to="/all-best-selling-product" className="px-6 py-2 bg-[#9D2326] text-white rounded-md hover:bg-black transition-all">
                                                                            Explore Best Sellers
                                                                        </Link>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )
            }
        </div >
    )
}

export default User_Dashboard_Wishlist